import Logger from "../../../common/util/Logger";
import { EpicFactory } from "../../../core/core-redux/reduxTypes";
import { Action } from "redux";
import { RootState } from "../../../rootState";
import {
    STORE_GIS_SERVER_URL,
    StoreGisServerUrlAction,
} from "../../../layers/redux/gis-server-url/storeGisServerUrl.action";
import { ChangeToColorMappingType } from "../../types";

import { saveChangeTypeColoringAction } from "./";
const axios = require("@mapstore/libs/ajax");
const Rx = require("rxjs");
const { doNothingAction } = require("@js/common/action/doNothingAction");
const { gisServerUrlSelector } = require("@js/common/selector/configurationSelector");

const logger = new Logger("changeColoringEpic");

interface GetChangeTypeMappingResponse {
    data: ChangeToColorMappingType;
}

function getChangeTypeMapping(url: string) {
    const retrieveFlow = () =>
        Rx.Observable.defer(() =>
            axios({
                method: "get",
                url: url,
            })
        );
    return retrieveFlow().map((response: GetChangeTypeMappingResponse) => ({ data: response.data }));
}

export const changeColoringEpic: EpicFactory<Action, RootState, Action> = (action, store) =>
    action.ofType<StoreGisServerUrlAction>(STORE_GIS_SERVER_URL).switchMap(() => {
        const state = store.getState();
        const gisServerUrl = gisServerUrlSelector(state);
        const gisServerRestUrl = `${gisServerUrl}/rest/sdo/changeTypeColorMapping`;

        return getChangeTypeMapping(gisServerRestUrl)
            .map((response: GetChangeTypeMappingResponse) => saveChangeTypeColoringAction(response.data))
            .catch((e: Error) => {
                logger.error("Error retrieving change type coloring from GIS Server.", e);
                return [doNothingAction()];
            });
    });
